import script from "./EbgImageObject.vue?vue&type=script&setup=true&lang=ts"
export * from "./EbgImageObject.vue?vue&type=script&setup=true&lang=ts"

import "./EbgImageObject.vue?vue&type=style&index=0&id=887b778c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src057020910/src/SAAS-mobile-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-887b778c"]])

export default __exports__